import {Box, Chip, Divider, FormControl, FormLabel} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import plusIcon from "../../../assets/img/proposal-img/plus_icon.svg";
import minusIcon from "../../../assets/img/proposal-img/minus_icon.svg";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {setUiData} from "../../../store/uiSlice";
import {PROPOSAL_FORM} from "../../../constants/apiConstant";
import GlobalRadio from "../../global-fields/GlobalRadio";
import {
  hasEmptyField,
  parseToNumber,
  normalizeCurrencyToNumber,
  removeCookies,
  USD_FORMATTER,
  initialFormValidations,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {MANDATORY_QUES} from "../../../constants/constants";
import {motion} from "framer-motion";
import {fadeSlideIn} from "../../../constants/motionConstants";
import {
  amountSchemaWithoutRequired,
  numberSchema,
  numberSchemaWithoutRequired,
} from "../../../constants/validationSchemas";

const StepNineForm = ({leftGridWidth}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep9Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const propertyOutsideLimit = 10;
  const elsewhereLimit = 10;
  const [disableDraft, setDisableDraft] = useState(false);
  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {
      ...e,
      user_id: user?.id,
      proposal_id,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
      step: proposalStep,
      // custody_commission: normalizeCurrencyToNumber(e.custody_commission),
      goods_in_the_custody: e.goods_in_the_custody?.map((item) => ({
        ...item,
        avg_amt_carry: normalizeCurrencyToNumber(item.avg_amt_carry),
        max_amt_carry: normalizeCurrencyToNumber(item.max_amt_carry),
      })),
      goods_elsewhere: e.goods_elsewhere?.map((item) => ({
        ...item,
        avg_amt_carry: normalizeCurrencyToNumber(item.avg_amt_carry),
        max_amt_carry: normalizeCurrencyToNumber(item.max_amt_carry),
      })),

      goods_in_custody_in_excess_of: e.goods_in_custody_in_excess_of,

      goods_elsewhere_in_excess_of: e.goods_elsewhere_in_excess_of,
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }
    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };
  const propStep9DataMemoize = useMemo(() => propStep9Data, [propStep9Data]);
  const initialValues = {
    step: 9,
    // custody_commission:
    //   propStep9DataMemoize?.custody_commission == 0 ||
    //   propStep9DataMemoize?.custody_commission == "0" ||
    //   propStep9DataMemoize?.custody_commission
    //     ? USD_FORMATTER.format(propStep9DataMemoize?.custody_commission)
    //     : "",
    // proposers_cities: propStep9DataMemoize?.proposers_cities ?? "",
    goods_in_custody_two_person_warranty:
      propStep9DataMemoize?.goods_in_custody_two_person_warranty ?? "",

   goods_in_custody_in_excess_of:
  propStep9DataMemoize?.goods_in_custody_in_excess_of ?? "",

    goods_elsewhere_two_person_warranty:
      propStep9DataMemoize?.goods_elsewhere_two_person_warranty ?? "",

    goods_elsewhere_in_excess_of:
  propStep9DataMemoize?.goods_elsewhere_in_excess_of ?? "",
    goods_in_the_custody:
      propStep9DataMemoize?.goods_in_the_custody?.length > 0
        ? propStep9DataMemoize.goods_in_the_custody.map((item) => ({
            ...item,
            avg_amt_carry:
              item.avg_amt_carry == 0 ||
              item.avg_amt_carry == "0" ||
              item.avg_amt_carry
                ? USD_FORMATTER.format(item.avg_amt_carry)
                : "",
            max_amt_carry:
              item.max_amt_carry == 0 ||
              item.max_amt_carry == "0" ||
              item.max_amt_carry
                ? USD_FORMATTER.format(item.max_amt_carry)
                : "",
          }))
        : [
            {
              name: "",
              no_of_days: "",
              avg_amt_carry: "",
              max_amt_carry: "",
            },
          ],

    goods_elsewhere:
      propStep9DataMemoize?.goods_elsewhere?.length > 0
        ? propStep9DataMemoize.goods_elsewhere.map((item) => ({
            ...item,
            avg_amt_carry:
              item.avg_amt_carry == 0 ||
              item.avg_amt_carry == "0" ||
              item.avg_amt_carry
                ? USD_FORMATTER.format(item.avg_amt_carry)
                : "",
            max_amt_carry:
              item.max_amt_carry == 0 ||
              item.max_amt_carry == "0" ||
              item.max_amt_carry
                ? USD_FORMATTER.format(item.max_amt_carry)
                : "",
          }))
        : [
            {
              name: "",
              no_of_days: "",
              avg_amt_carry: "",
              max_amt_carry: "",
            },
          ],
  };

  // useEffect(() => {
  //   if (propStep9DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep9DataMemoize]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      // custody_commission: amountSchemaWithRequired,
      // proposers_cities: amountSchemaWithRequired,
      goods_in_the_custody: Yup.array().of(
        Yup.object().shape({
          name: Yup.string().notRequired(),
          no_of_days: numberSchemaWithoutRequired,
          avg_amt_carry: amountSchemaWithoutRequired,
          max_amt_carry: amountSchemaWithoutRequired,
        })
      ),
      goods_elsewhere: Yup.array().of(
        Yup.object().shape({
          name: Yup.string().notRequired(),
          no_of_days: numberSchemaWithoutRequired,
          avg_amt_carry: amountSchemaWithoutRequired,
          max_amt_carry: amountSchemaWithoutRequired,
        })
      ),

      goods_in_custody_two_person_warranty: Yup.string().notRequired(),

      goods_in_custody_in_excess_of: Yup.string().when(
          "goods_in_custody_two_person_warranty",
          {
              is: "Yes",
              then: () => Yup.string().required(),
              otherwise: () => Yup.string(),
          }
      ),

      goods_elsewhere_two_person_warranty: Yup.string().notRequired(),

      goods_elsewhere_in_excess_of: Yup.string().when(
          "goods_elsewhere_two_person_warranty",
          {
              is: "Yes",
              then: () => Yup.string().required(),
              otherwise: () => Yup.string(),
          }
      ),
      // goods_in_the_custody: Yup.array().of(
      //   Yup.object().shape({
      //     name: Yup.string().required(MANDATORY_QUES),
      //     no_of_days: numberSchema,
      //     avg_amt_carry: amountSchemaWithRequired,
      //     max_amt_carry: amountSchemaWithRequired,
      //   })
      // ),
      // goods_elsewhere: Yup.array().of(
      //   Yup.object().shape({
      //     name: Yup.string().notRequired(),
      //     no_of_days: numberSchemaWithoutRequired,
      //     avg_amt_carry: amountSchemaWithoutRequired,
      //     max_amt_carry: amountSchemaWithoutRequired,
      //   })
      // ),
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 9:", values);
      handleStepData(values);
    },
  });

  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 9) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  const handlePlusGoodsInCust = useCallback(() => {
    const lastgoods_in_the_custody =
      formik.values.goods_in_the_custody[
        formik.values.goods_in_the_custody.length - 1
      ];

    if (
      !lastgoods_in_the_custody.name ||
      !lastgoods_in_the_custody.no_of_days ||
      !lastgoods_in_the_custody.avg_amt_carry ||
      !lastgoods_in_the_custody.max_amt_carry
    ) {
      GlobalNotificationPopup({
        type: "warning",
        message: "Please fill all fields before adding a new entry.",
      });
      return;
    }

    if (formik.values.goods_in_the_custody.length >= propertyOutsideLimit)
      return;

    formik.setFieldValue("goods_in_the_custody", [
      ...formik.values.goods_in_the_custody,
      {
        name: "",
        no_of_days: "",
        avg_amt_carry: "",
        max_amt_carry: "",
      },
    ]);
  }, [formik.values.goods_in_the_custody]);
  const handleMinusGoodsInCust = useCallback(
    (index) => {
      if (formik.values.goods_in_the_custody.length === 1) return;

      const newgoods_in_the_custody = [...formik.values.goods_in_the_custody];
      newgoods_in_the_custody.splice(index, 1);
      formik.setFieldValue("goods_in_the_custody", newgoods_in_the_custody);
    },
    [formik.values.goods_in_the_custody]
  );
  const handlePlusGoodsElse = useCallback(() => {
    const lastgoods_elsewhere =
      formik.values.goods_elsewhere[formik.values.goods_elsewhere.length - 1];

    if (
      !lastgoods_elsewhere.name ||
      !lastgoods_elsewhere.no_of_days ||
      !lastgoods_elsewhere.avg_amt_carry ||
      !lastgoods_elsewhere.max_amt_carry
    ) {
      GlobalNotificationPopup({
        type: "warning",
        message: "Please fill all fields before adding a new entry.",
      });
      return;
    }

    if (formik.values.goods_elsewhere.length >= elsewhereLimit) return;

    formik.setFieldValue("goods_elsewhere", [
      ...formik.values.goods_elsewhere,
      {
        name: "",
        no_of_days: "",
        avg_amt_carry: "",
        max_amt_carry: "",
      },
    ]);
  }, [formik.values.goods_elsewhere]);
  const handleMinusGoodsElse = useCallback(
    (index) => {
      if (formik.values.goods_elsewhere.length === 1) return;

      const newgoods_elsewhere = [...formik.values.goods_elsewhere];
      newgoods_elsewhere.splice(index, 1);
      formik.setFieldValue("goods_elsewhere", newgoods_elsewhere);
    },
    [formik.values.goods_elsewhere]
  );

  const handleAmountFieldChangeOLD = (e, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    formik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };
  const handleAmountFieldChange = (e, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$." without formatting
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      // Format integer with commas
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      // Append decimal part if exists, limit to 2 digits
      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };
  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Travel</h2>
            <form
              autoComplete="false"
              autoSave="false"
              onSubmit={handleCustomSubmit}
            >
              {/* <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                  <h2 className={style.formTitleh2}>
                    20) What limits do you desire for section 2 of the policy?
                  </h2>
                </Grid>

                <Grid size={{xs: 12, md: 12}}>
                  <h3 className={style.htitleText}>
                    In Custody of Commission Sales men or selling Agents
                  </h3>
                </Grid>

                <Grid size={{xs: 12, md: 4}}>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`custody_commission`}
                    id={`_custody_commission`}
                    value={formik.values?.custody_commission}
                    onChange={(e) =>
                      handleAmountFieldChange(e, "custody_commission")
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.custody_commission &&
                      Boolean(formik.errors?.custody_commission)
                    }
                    helperText={
                      formik.touched?.custody_commission &&
                      formik.errors?.custody_commission
                    }
                  />
                </Grid>
              </Grid> */}

              <Grid container spacing={2} sx={{mt: 3}}>
                <Grid size={{xs: 12}}>
                  <h2 className={style.formTitleh2}>
                    19) Property Outside of our Premises as set forth in
                    question
                  </h2>
                  <Box sx={{mt: 1}}>
                    <p className={style.htitleText + " " + style.noteText}>
                      <u>Note</u> : All carrying of goods outside of Proposer’s
                      premises must be reported in this section.
                    </p>
                  </Box>
                  {/*               <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                    <h3 className={style.htitleText}>
                      In cities or towns in which the Proposer’s are situated:
                    </h3>
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ mt: 2 }}>
                    <GlobalTextField
                      placeH="$"
                      type="text"
                      name={`proposers_cities`}
                      id={`_proposers_cities`}
                      value={formik.values?.proposers_cities}
                      onChange={(e) =>
                        handleAmountFieldChange(e, "proposers_cities")
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.proposers_cities &&
                        Boolean(formik.errors?.proposers_cities)
                      }
                      helperText={
                        formik.touched?.proposers_cities &&
                        formik.errors?.proposers_cities
                      }
                    />
                  </Grid> */}
                </Grid>

                <Grid size={{xs: 12, md: 12}} sx={{mt: 0}}>
                  <div className={style.plusIconMain}>
                    <h3 className={style.htitleText}>
                      In the custody of the Proposer, Employees, Members of the
                      Firm, Officers of the Corporation or Salesmen.
                    </h3>

                    <div
                      className={style.plusImgMain + " " + style.plusImgWidth}
                    >
                      {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                      {formik.values.goods_in_the_custody.length <
                        propertyOutsideLimit && (
                        <p
                          style={{
                            position: "inherit",
                            display: "flex",
                          }}
                          onClick={handlePlusGoodsInCust}
                        >
                          <img
                            src={plusIcon}
                            alt="Add"
                            style={{marginRight: "5px"}}
                          />
                          Add
                        </p>
                      )}
                    </div>
                  </div>
                </Grid>
                {formik.values.goods_in_the_custody.map((gc, index) => {
                  return (
                    <>
                      {index !== 0 && (
                        <Box sx={{width: "100%", mt: 1, mb: 1}}>
                          <Divider sx={{position: "relative"}}>
                            <Chip
                              label={`${index + 1}`}
                              size="medium"
                              clickable
                              onDelete={() => handleMinusGoodsInCust(index)}
                            />
                          </Divider>
                        </Box>
                      )}
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}> Name </FormLabel>
                        </FormControl>
                        <GlobalTextField
                          id={`goods_in_the_custody.${index}.name`}
                          name={`goods_in_the_custody.${index}.name`}
                          value={
                            formik.values?.goods_in_the_custody?.[index]?.name
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.goods_in_the_custody?.[index]
                              ?.name &&
                            Boolean(
                              formik.errors?.goods_in_the_custody?.[index]?.name
                            )
                          }
                          helperText={
                            formik.touched?.goods_in_the_custody?.[index]
                              ?.name &&
                            formik.errors?.goods_in_the_custody?.[index]?.name
                          }
                        />
                      </Grid>
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}> Number of Days </FormLabel>
                        </FormControl>
                        <GlobalTextField
                          id={`goods_in_the_custody.${index}.no_of_days`}
                          name={`goods_in_the_custody.${index}.no_of_days`}
                          value={
                            formik.values?.goods_in_the_custody?.[index]
                              ?.no_of_days
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.goods_in_the_custody?.[index]
                              ?.no_of_days &&
                            Boolean(
                              formik.errors?.goods_in_the_custody?.[index]
                                ?.no_of_days
                            )
                          }
                          helperText={
                            formik.touched?.goods_in_the_custody?.[index]
                              ?.no_of_days &&
                            formik.errors?.goods_in_the_custody?.[index]
                              ?.no_of_days
                          }
                        />
                      </Grid>
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}>
                            Average Amount Carry
                          </FormLabel>
                        </FormControl>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          id={`goods_in_the_custody.${index}.avg_amt_carry`}
                          name={`goods_in_the_custody.${index}.avg_amt_carry`}
                          value={
                            formik.values?.goods_in_the_custody?.[index]
                              ?.avg_amt_carry
                          }
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              `goods_in_the_custody.${index}.avg_amt_carry`
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.goods_in_the_custody?.[index]
                              ?.avg_amt_carry &&
                            Boolean(
                              formik.errors?.goods_in_the_custody?.[index]
                                ?.avg_amt_carry
                            )
                          }
                          helperText={
                            formik.touched?.goods_in_the_custody?.[index]
                              ?.avg_amt_carry &&
                            formik.errors?.goods_in_the_custody?.[index]
                              ?.avg_amt_carry
                          }
                        />
                      </Grid>
                      <Grid size={{xs: 12, md: 3}}>
                        {/* <div className={style.plusIconMain}>
                          <div style={{ width: "100%" }}> */}
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}> Max Amount Carry</FormLabel>
                        </FormControl>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          id={`goods_in_the_custody.${index}.max_amt_carry`}
                          name={`goods_in_the_custody.${index}.max_amt_carry`}
                          value={
                            formik.values?.goods_in_the_custody?.[index]
                              ?.max_amt_carry
                          }
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              `goods_in_the_custody.${index}.max_amt_carry`
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.goods_in_the_custody?.[index]
                              ?.max_amt_carry &&
                            Boolean(
                              formik.errors?.goods_in_the_custody?.[index]
                                ?.max_amt_carry
                            )
                          }
                          helperText={
                            formik.touched?.goods_in_the_custody?.[index]
                              ?.max_amt_carry &&
                            formik.errors?.goods_in_the_custody?.[index]
                              ?.max_amt_carry
                          }
                        />
                        {/* </div>
                          <div className={style.plusImgMain + " " + style.plusImgWidth}>
                            {formik.values.goods_in_the_custody.length > 1 && (
                              <p onClick={() => handleMinusGoodsInCust(index)}>
                                <img src={minusIcon} alt="minus" />
                              </p>
                            )}

                            {index ===
                              formik.values.goods_in_the_custody.length - 1 && (
                                <p onClick={handlePlusGoodsInCust}>
                                  <img src={plusIcon} alt="add" />
                                </p>
                              )}
                          </div>
                        </div> */}
                      </Grid>
                    </>
                  );
                })}
              </Grid>

              <Grid container spacing={2} sx={{ mt: 2 }} alignItems="flex-start">

    <Grid size={{ xs: 12, md: 6 }}>
        <FormLabel sx={{ mb: 1 }}>Two Person Warranty</FormLabel>

        <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
                <GlobalRadio
                    title="Yes"
                    selected={formik.values.goods_in_custody_two_person_warranty === "Yes"}
                    onClick={(e) => {
                        e.preventDefault();
                        formik.setFieldValue("goods_in_custody_two_person_warranty", "Yes");
                    }}
                />
            </Grid>

            <Grid size={{ xs: 6 }}>
                <GlobalRadio
                    title="No"
                    selected={formik.values.goods_in_custody_two_person_warranty === "No"}
                    onClick={(e) => {
                        e.preventDefault();
                        formik.setFieldValue("goods_in_custody_two_person_warranty", "No");
                        formik.setFieldValue("goods_in_custody_in_excess_of", "");
                    }}
                />
            </Grid>
        </Grid>
    </Grid>

    {formik.values.goods_in_custody_two_person_warranty === "Yes" && (
        <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>In Excess Of</FormLabel>
            </FormControl>

            <GlobalTextField
                type="text"
                name="goods_in_custody_in_excess_of"
                value={formik.values.goods_in_custody_in_excess_of}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.goods_in_custody_in_excess_of &&
                  Boolean(formik.errors.goods_in_custody_in_excess_of)
                }
                helperText={
                  formik.touched.goods_in_custody_in_excess_of &&
                  formik.errors.goods_in_custody_in_excess_of
                }
              />
        </Grid>
    )}

</Grid>

              <Grid container spacing={2} sx={{mt: 3}}>
                <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                  <div className={style.plusIconMain}>
                    <h3 className={style.htitleText}>
                      Elsewhere in United States, the District of Columbia,
                      Canada and Puerto Rico
                    </h3>

                    <div
                      className={style.plusImgMain + " " + style.plusImgWidth}
                    >
                      {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                      {formik.values.goods_elsewhere.length <
                        elsewhereLimit && (
                        <p
                          style={{
                            position: "inherit",
                            display: "flex",
                          }}
                          onClick={handlePlusGoodsElse}
                        >
                          <img
                            src={plusIcon}
                            alt="Add"
                            style={{marginRight: "5px"}}
                          />
                          Add
                        </p>
                      )}
                    </div>
                  </div>
                </Grid>
                {formik.values.goods_elsewhere.map((ge, index) => {
                  return (
                    <>
                      {index !== 0 && (
                        <Box sx={{width: "100%", mt: 1, mb: 1}}>
                          <Divider sx={{position: "relative"}}>
                            <Chip
                              label={`${index + 1}`}
                              size="medium"
                              clickable
                              onDelete={() => handleMinusGoodsElse(index)}
                            />
                          </Divider>
                        </Box>
                      )}
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}> Name </FormLabel>
                        </FormControl>
                        <GlobalTextField
                          id={`goods_elsewhere.${index}.name`}
                          name={`goods_elsewhere.${index}.name`}
                          value={formik.values?.goods_elsewhere?.[index]?.name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.goods_elsewhere?.[index]?.name &&
                            Boolean(
                              formik.errors?.goods_elsewhere?.[index]?.name
                            )
                          }
                          helperText={
                            formik.touched?.goods_elsewhere?.[index]?.name &&
                            formik.errors?.goods_elsewhere?.[index]?.name
                          }
                        />
                      </Grid>
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}> Number of Days </FormLabel>
                        </FormControl>

                        <GlobalTextField
                          id={`goods_elsewhere.${index}.no_of_days`}
                          name={`goods_elsewhere.${index}.no_of_days`}
                          value={
                            formik.values?.goods_elsewhere?.[index]?.no_of_days
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.goods_elsewhere?.[index]
                              ?.no_of_days &&
                            Boolean(
                              formik.errors?.goods_elsewhere?.[index]
                                ?.no_of_days
                            )
                          }
                          helperText={
                            formik.touched?.goods_elsewhere?.[index]
                              ?.no_of_days &&
                            formik.errors?.goods_elsewhere?.[index]?.no_of_days
                          }
                        />
                      </Grid>
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}>
                            Average Amount Carry
                          </FormLabel>
                        </FormControl>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          id={`goods_elsewhere.${index}.avg_amt_carry`}
                          name={`goods_elsewhere.${index}.avg_amt_carry`}
                          value={
                            formik.values?.goods_elsewhere?.[index]
                              ?.avg_amt_carry
                          }
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              `goods_elsewhere.${index}.avg_amt_carry`
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.goods_elsewhere?.[index]
                              ?.avg_amt_carry &&
                            Boolean(
                              formik.errors?.goods_elsewhere?.[index]
                                ?.avg_amt_carry
                            )
                          }
                          helperText={
                            formik.touched?.goods_elsewhere?.[index]
                              ?.avg_amt_carry &&
                            formik.errors?.goods_elsewhere?.[index]
                              ?.avg_amt_carry
                          }
                        />
                      </Grid>

                      <Grid size={{xs: 12, md: 3}}>
                        {/* <div className={style.plusIconMain}>
                          <div style={{ width: "100%" }}> */}
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}>Max Amount Carry</FormLabel>
                        </FormControl>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          id={`goods_elsewhere.${index}.max_amt_carry`}
                          name={`goods_elsewhere.${index}.max_amt_carry`}
                          value={
                            formik.values?.goods_elsewhere?.[index]
                              ?.max_amt_carry
                          }
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              `goods_elsewhere.${index}.max_amt_carry`
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.goods_elsewhere?.[index]
                              ?.max_amt_carry &&
                            Boolean(
                              formik.errors?.goods_elsewhere?.[index]
                                ?.max_amt_carry
                            )
                          }
                          helperText={
                            formik.touched?.goods_elsewhere?.[index]
                              ?.max_amt_carry &&
                            formik.errors?.goods_elsewhere?.[index]
                              ?.max_amt_carry
                          }
                        />
                        {/* </div>
                          <div className={style.plusImgMain + " " + style.plusImgWidth}>
                            {formik.values.goods_elsewhere.length > 1 && (
                              <p onClick={() => handleMinusGoodsElse(index)}>
                                <img src={minusIcon} alt="minus" />
                              </p>
                            )}

                            {index ===
                              formik.values.goods_elsewhere.length - 1 && (
                                <p onClick={handlePlusGoodsElse}>
                                  <img src={plusIcon} alt="add" />
                                </p>
                              )}
                          </div>
                        </div> */}
                      </Grid>
                    </>
                  );
                })}
              </Grid>
                <Grid container spacing={2} sx={{ mt: 2 }} alignItems="flex-start">

    <Grid size={{ xs: 12, md: 6 }}>
        <FormLabel sx={{ mb: 1 }}>Two Person Warranty</FormLabel>

        <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
                <GlobalRadio
                    title="Yes"
                    selected={
                        formik.values.goods_elsewhere_two_person_warranty === "Yes"
                    }
                    onClick={(e) => {
                        e.preventDefault();
                        formik.setFieldValue(
                            "goods_elsewhere_two_person_warranty",
                            "Yes"
                        );
                    }}
                />
            </Grid>

            <Grid size={{ xs: 6 }}>
                <GlobalRadio
                    title="No"
                    selected={
                        formik.values.goods_elsewhere_two_person_warranty === "No"
                    }
                    onClick={(e) => {
                        e.preventDefault();

                        formik.setFieldValue(
                            "goods_elsewhere_two_person_warranty",
                            "No"
                        );

                        formik.setFieldValue(
                            "goods_elsewhere_in_excess_of",
                            ""
                        );
                    }}
                />
            </Grid>
        </Grid>
    </Grid>

    {formik.values.goods_elsewhere_two_person_warranty === "Yes" && (
        <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>
                    In Excess Of
                </FormLabel>
            </FormControl>
            <GlobalTextField
              type="text"
              name="goods_elsewhere_in_excess_of"
              value={formik.values.goods_elsewhere_in_excess_of}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.goods_elsewhere_in_excess_of &&
                Boolean(formik.errors.goods_elsewhere_in_excess_of)
              }
              helperText={
                formik.touched.goods_elsewhere_in_excess_of &&
                formik.errors.goods_elsewhere_in_excess_of
              }
            />

            
        </Grid>
    )}

</Grid>
            </form>
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            !hasEmptyField(formik.values) &&
            !formik.dirty &&
            propStep9DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
    </>
  );
};

export default StepNineForm;
